module.exports = __webpack_public_path__ + "img/thebosco.76e29462.jpg";